import { RegisterType, UserDataType } from "types/auth.type.ts";
import { api } from "./base.api.ts";

export const emailDuplicity = async (email: string) => {
  await api.post("check-email-duplicate", { email });
};

export const sendOTP = async (data) => {
  await api.post("send-otp", data);
};

export const resendOTP = async (data) => {
  await api.post("resend-confirm-otp", data);
};

export const otpVerify = async (data) => {
  await api.post("verify-otp",data);
};

export const register = async (
  newTeacher: RegisterType
): Promise<{
  status: number;
  token: string;
  data: UserDataType;
}> => {
  const res = await api.post("register", newTeacher);
  return res.data;
};

export const login = async (credentials) => {
  const res = await api.post("login", credentials);
  return res.data;
};

export const getUserDetail = async (): Promise<UserDataType> => {
  const res = await api.get("getUserProfileDetails");
  return res.data.data;
};

export const forgotPass = async (email) => {
  await api.post("forgot-password", { email });
};

export const resetPassword = async (resetPassword) => {
  await api.post("reset-password", resetPassword);
};
